import { useSelector } from 'react-redux'

import api from 'containers/api'
import { selectToken } from 'containers/authentication/authenticationSlice'
import useMutator from 'containers/mutator'

// 'add' appends the file's rows; 'replace' swaps the organization's expenses
// for the file's contents (so a downloaded CSV can be edited and re-uploaded
// without duplicating every row).
export type ManualExpenseImportMode = 'add' | 'replace'

const useImportManualExpenses = (organizationId: number | null) => {
  const token = useSelector(selectToken)
  // One payload object, not two args: useMutator forwards a single argument.
  const importExpenses = async ({
    file,
    mode,
  }: {
    file: File
    mode: ManualExpenseImportMode
  }) => {
    if (organizationId) {
      return api.importManualExpenses({
        organizationId: organizationId,
        token,
        file,
        mode,
      })
    } else {
      throw new Error('organization not loaded yet')
    }
  }
  return useMutator(importExpenses)
}

export default useImportManualExpenses
